module.exports = __webpack_public_path__ + "static/media/wine-glass.7a0076fb.svg";